import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Client } from 'src/app/core/models/client';
import { ClientService } from 'src/app/core/services/general/client.service';

@Component({
  selector: 'app-client-input',
  templateUrl: './client-input.component.html',
  styleUrls: ['./client-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ClientInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ClientInputComponent,
    },
  ],
})
export class ClientInputComponent {
  @Input()
  title = "Select Client...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public clientsList: Array<CustomSelectOption> = [];

  constructor(
    private clientService: ClientService,
  ) {
    this.clientService
      .all()
      .subscribe((res: Array<Client>) => {
        this.clientsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.clientsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
